import { sdk } from 'src/utilities/sdk';

export async function sendWelcomeEmailToDiner(
  corpId: string,
  dinerId: string
): Promise<void> {
  const dinerWelcomeEmailLink = `/corps/${corpId}/diners/${dinerId}/sendWelcomeEmail`;

  await sdk.http.post(dinerWelcomeEmailLink, {});
}
